import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.css'],
  standalone: false
})
export class SupportTicketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
